/**
 * @author Fernando Ruano
 * @file es.js
 * @description Spanish translations
 */

// Translations
import login from '@nephro/pages/Login/messages';
import components from '@nephro/pages/ComponentsState/messages';
import registration from '@nephro/pages/PatientRegistration/messages';
import passwordRecovery from '@nephro/pages/PasswordRecovery/messages';
import patientManagement from '@nephro/pages/Patients/PatientManagement/messages';
import patientRecords from '@nephro/pages/PatientRecords/messages';
import DashboardDetail from '@nephro/pages/DashboardDetail/messages';
import calendarManagement from '@nephro/pages/MyAppointments/messages';
import roleManagement from '@nephro/pages/Roles/RolesManagement/messages';
import profileManagement from '@nephro/pages/Profiles/ProfilesManagement/messages';
import paramManagement from '@nephro/pages/Parameters/ParametersManagement/messages';
import countryUserRoleManagement from '@nephro/pages/CountryUserRoles/CountryUserRolesManagement/messages';
import dashboard from '@nephro/containers/Dashboard/messages';
import pageHeader from '@nephro/components/PageHeader/messages';
import commons from '@nephro/commons/messages';
import errors from '@nephro/commons/messagesError';
import previewDocuments from '@nephro/components/PreviewDocuments/messages';
import indicators from '@nephro/pages/Indicators/messages';
import dashboardPatient from '@nephro/pages/DashboardPatient/messages';
import educationalMaterial from '@nephro/pages/EducationalMaterial/messages';
import patientEvents from '@nephro/pages/PatientEvents/messages';
import termsAndConditions from '@nephro/pages/About/TermsAndConditions/messages';
import about from '@nephro/pages/About/messages';
import dashboardStaff from '@nephro/pages/DashboardStaff/messages';

export default {
  login: { ...login.es },
  dashboardStaff: { ...dashboardStaff.es },
  components: { ...components.es },
  dashboard: { ...dashboard.es },
  commons: { ...commons.es },
  errors: { ...errors.es },
  patientMg: { ...patientManagement.es },
  roleMg: { ...roleManagement.es },
  paramMg: { ...paramManagement.es },
  calendarMg: { ...calendarManagement.es },
  curMg: { ...countryUserRoleManagement.es },
  profileMg: { ...profileManagement.es },
  pageHeader: { ...pageHeader.es },
  registration: { ...registration.es },
  previewDocuments: { ...previewDocuments.es },
  passwordRecovery: { ...passwordRecovery.es },
  dashboardDet: { ...DashboardDetail.es },
  indicators: { ...indicators.es },
  dashboardPatient: { ...dashboardPatient.es },
  patientRecords: { ...patientRecords.es },
  educationalMaterial: { ...educationalMaterial.es },
  patientEvents: { ...patientEvents.es },
  termsAndConditions: { ...termsAndConditions.es },
  about: { ...about.es }
};
